export const LABEL_SHOW_RESET = 'LABEL_SHOW_RESET'
export const LABEL_SHOW_SET_ERROR = 'LABEL_SHOW_SET_ERROR'
export const LABEL_SHOW_SET_RETRIEVED = 'LABEL_SHOW_SET_RETRIEVED'
export const LABEL_SHOW_TOGGLE_LOADING = 'LABEL_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/label/show/mutation_types.js